import Button from '@repo/ui/button'
import RadioInput from '@repo/ui/radio-input'

import { API } from '../../../api/apis.config'
import useTranslate from '../../../lib/hooks/use-translate'
import { Staff, StaffFilters } from '../../../lib/types/models/staff/staff'
import { getStaffColumns } from '../../../views/staffs/utils'
import DynamicDataTable from '../../elements/dynamic-table'

type Props = {
  filters?: StaffFilters
  onStaffSelect: (staff: Staff) => void
  staffId?: number
  onSave?: () => void
  onCancel?: () => void
}

const AssignStaff = ({ onStaffSelect, staffId, onSave, onCancel, filters }: Props) => {
  const { t } = useTranslate()

  return (
    <div className={'divide-y divide-white-active space-y-4'}>
      <DynamicDataTable<Staff, StaffFilters>
        headerType="light"
        title={'Tous les séjours'}
        filters={filters}
        columns={[
          {
            accessorKey: 'id',
            header: '',
            cell: ({ row }) => (
              <RadioInput
                name="staff"
                checked={row.original.id === staffId}
                onCheck={() => onStaffSelect(row.original)}
              />
            )
          },
          ...getStaffColumns('PARTIAL', t)
        ]}
        endpoint={API.staffs.getAll.url}
        permissions={{ delete: false }}
      />
      <div className="flex justify-end w-full gap-3 pt-5">
        <Button variant="ghost" label={'Fermer'} onClick={onCancel} />
        <Button variant="primary" label={'Suivant'} disabled={!staffId} onClick={onSave} />
      </div>
    </div>
  )
}

export default AssignStaff
